import { Injectable } from '@angular/core';
import { RecipeDetailResponseModel } from 'src/app/core/model/api-response/recipe-response-model';

@Injectable({
  providedIn: 'root',
})
export class CookingStoryService {
  private recipe: RecipeDetailResponseModel;
  private lastCategorieId: string = null;
  constructor() {}
  saveRecipe(data: RecipeDetailResponseModel) {
    this.recipe = data;
  }
  getRecipe(): RecipeDetailResponseModel {
    return this.recipe;
  }
  saveCategorieId(data: string) {
    this.lastCategorieId = data;
  }
  getCategorieId(): string {
    return this.lastCategorieId;
  }
}
